<template>
  <el-row justify="center">
    <el-col :xs="24" :sm="20" :md="16" :lg="12">

      <el-card shadow="never">
        <template #header>
          <div class="card-header">
            <h5 class="mb-0">上传我的成果</h5>
          </div>
        </template>

        <el-alert
          v-if="uploadSuccess"
          :title="uploadSuccess"
          type="success"
          show-icon
          class="mb-3"
        >
          <el-button type="success" plain @click="$router.push('/resources')">
            返回资源库
          </el-button>
        </el-alert>
        <el-alert
          v-if="uploadError"
          :title="uploadError"
          type="error"
          show-icon
          class="mb-3"
          :closable="false"
        />

        <el-form
          :model="uploadForm"
          :rules="formRules"
          ref="uploadFormRef"
          label-position="top"
          @submit.prevent="handleSubmitUpload"
        >
          <el-form-item label="资源标题" prop="title">
            <el-input
              v-model="uploadForm.title"
              placeholder="请输入资源标题"
            />
          </el-form-item>

          <el-form-item label="资源描述" prop="description">
            <el-input
              v-model="uploadForm.description"
              type="textarea"
              :rows="3"
              placeholder="简单介绍一下您的资源..."
            />
          </el-form-item>

          <el-form-item label="资源文件" prop="file">
            <el-upload
              ref="uploadRef"
              action="#"
              :auto-upload="false"
              :limit="1"
              :on-exceed="handleFileExceed"
              :on-change="handleFileChange"
              class="w-100"
            >
              <el-button type="default" class="w-100">
                <i class="fas fa-upload me-2"></i>
                {{ selectedFile ? `已选择: ${selectedFile.name}` : '点击选择文件' }}
              </el-button>
              <template #tip>
                <div class="el-upload__tip">
                  请上传 PDF、Word、PPT 或图片。
                </div>
              </template>
            </el-upload>
          </el-form-item>
          <el-form-item class="mt-4">
            <el-button
              type="primary"
              size="large"
              @click="handleSubmitUpload"
              :loading="isUploading"
            >
              {{ isUploading ? '正在上传...' : '确认上传' }}
            </el-button>
            <el-button size="large" @click="$router.push('/resources')">
              取消
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>

    </el-col>
  </el-row>
</template>

<script>
//
// <script> 部分完全保持不变
// (V3.0 的逻辑是完美的, V4.0 只是“换皮”)
//
import axios from 'axios';
import { ElMessage } from 'element-plus'; // (导入 ElMessage)

export default {
  name: 'UploadResourceView',
  data() {
    return {
      isUploading: false,
      uploadForm: {
        title: '',
        description: '',
      },
      selectedFile: null,
      uploadSuccess: null,
      uploadError: null,

      // 【V4.0】 表单验证规则
      formRules: {
        title: [
          { required: true, message: '资源标题不能为空。', trigger: 'blur' },
        ],
        file: [
          // (我们用 handleFileChange 来触发验证)
          { required: true, message: '您必须选择一个文件。', trigger: 'change' },
        ]
      }
    };
  },

  methods: {
    // 【V4.0】 el-upload 绑定
    handleFileChange(file, fileList) {
      if (fileList.length > 0) {
        this.selectedFile = file.raw;
      } else {
        this.selectedFile = null;
      }
      // (手动触发文件验证)
      this.$refs.uploadFormRef.validateField('file');
    },
    handleFileExceed(files) {
      this.$refs.uploadRef.clearFiles();
      this.$refs.uploadRef.handleStart(files[0]);
      this.selectedFile = files[0];
      this.$refs.uploadFormRef.validateField('file');
    },

    /**
     * 【POST】提交新资源 (使用 FormData)
     */
    async handleSubmitUpload() {
      // 1. 【V4.0】使用 el-form 的 'validate' 方法
      // (我们同时验证文件是否已选)
      if (!this.selectedFile) {
        this.$refs.uploadFormRef.validateField('file');
        ElMessage({ type: 'error', message: '您必须选择一个文件。' });
      }

      this.$refs.uploadFormRef.validate(async (valid) => {
        if (!valid || !this.selectedFile) {
          if (valid && !this.selectedFile) {
             // (do nothing, 消息已在上面显示)
          } else {
             ElMessage({ type: 'error', message: '请检查您的表单是否填写完整。' });
          }
          return false;
        }

        // --- 验证通过, 开始提交 ---
        this.isUploading = true;
        this.uploadSuccess = null;
        this.uploadError = null;

        const token = localStorage.getItem('authToken');
        const formData = new FormData();

        formData.append('title', this.uploadForm.title);
        formData.append('description', this.uploadForm.description);
        formData.append('file', this.selectedFile, this.selectedFile.name);

        try {
          // (API 保持不变)
          await axios.post('/members/api/resources/upload/', formData, {
            headers: {
              'Authorization': `Token ${token}`
            }
          });

          // (处理成功)
          this.uploadSuccess = '上传成功！您的资源将在管理员批准后显示在列表中。';
          this.$refs.uploadFormRef.resetFields();
          this.$refs.uploadRef.clearFiles();
          this.selectedFile = null;

        } catch (error) {
          console.error('上传资源失败:', error);
          this.uploadError = '上传失败，请稍后再试。';
        } finally {
          this.isUploading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
/* --- V4.0 样式 --- */
.w-100 {
  width: 100%;
}
.card-header h5 {
  font-weight: 600;
  margin-bottom: 0;
}
.mb-3 {
  margin-bottom: 1.25rem;
}
.mt-4 {
  margin-top: 1.5rem;
}
.me-2 {
  margin-right: 0.5rem;
}
/* 确保 el-upload 按钮占满宽度 */
.el-upload {
  width: 100%;
}
:deep(.el-upload) {
  width: 100%;
}
:deep(.el-upload-dragger) {
  width: 100% !important;
}
:deep(.el-upload .el-button) {
  width: 100%;
}
</style>